<template>
  <!-- 영역 1: Summary Header Card — REQ-FE-DETAIL-004 -->
  <a-card
    class="summary-header-card"
    style="margin-bottom: 16px;"
  >
    <div class="summary-grid">
      <!-- GTIN 정보 -->
      <div class="summary-field">
        <div class="summary-label">{{ $t('lotFlow_detail_summary_gtin') }}</div>
        <div class="summary-value gtin-mono" data-testid="summary-gtin">
          {{ summary.gtinDisplay || summary.gtinCode || '-' }}
          <a-tag v-if="summary.gs1CompanyPrefix3" color="blue" style="margin-left: 8px;">
            GS1: {{ summary.gs1CompanyPrefix3 }}
          </a-tag>
        </div>
      </div>

      <!-- 제품코드 매핑 -->
      <div class="summary-field">
        <div class="summary-label">{{ $t('lotFlow_detail_summary_productCodeMapping') }}</div>
        <div class="summary-value">
          <span class="code-mono">{{ summary.ecountProductCode || '-' }}</span>
          <span style="margin: 0 8px; color: #8c8c8c;">→</span>
          <span class="code-mono">{{ summary.dealerProductCode || '-' }}</span>
        </div>
      </div>

      <!-- 제품명 -->
      <div v-if="summary.productDescription" class="summary-field">
        <div class="summary-label">{{ $t('lotFlow_detail_summary_productDescription') }}</div>
        <div class="summary-value">{{ summary.productDescription }}</div>
      </div>

      <!-- 본사 출하 → 매입 갭 -->
      <div class="summary-field">
        <div class="summary-label">{{ $t('lotFlow_detail_summary_gapDays') }}</div>
        <div class="summary-value" data-testid="summary-gap-days">
          <span v-if="summary.ecountToDealerGapDays !== null && summary.ecountToDealerGapDays !== undefined">
            {{ $t('lotFlow_detail_summary_gapDaysValue', { days: summary.ecountToDealerGapDays }) }}
          </span>
          <span v-else>-</span>
        </div>
      </div>

      <!-- 정합성 체크 -->
      <div class="summary-field">
        <div class="summary-label">{{ $t('lotFlow_detail_summary_consistencyCheck') }}</div>
        <div class="summary-value">
          <a-tag
            v-if="summary.consistencyCheck"
            :color="consistencyColor(summary.consistencyCheck.quantityBalance)"
            data-testid="summary-consistency-qty"
          >
            {{ $t('lotFlow_detail_summary_quantityBalance') }}:
            {{ $t('lotFlow_detail_summary_consistency_' + (summary.consistencyCheck.quantityBalance || 'ok')) }}
          </a-tag>
          <a-tag
            v-if="summary.consistencyCheck"
            :color="consistencyColor(summary.consistencyCheck.timeline)"
            style="margin-left: 4px;"
            data-testid="summary-consistency-timeline"
          >
            {{ $t('lotFlow_detail_summary_timeline') }}:
            {{ $t('lotFlow_detail_summary_consistency_' + (summary.consistencyCheck.timeline || 'ok')) }}
          </a-tag>
        </div>
      </div>

      <!-- 활성 상태 -->
      <div class="summary-field">
        <div class="summary-label">{{ $t('lotFlow_detail_summary_activeStatus') }}</div>
        <div class="summary-value" data-testid="summary-active-status">
          <a-tag :color="activeStatusColor(summary.activeStatus)">
            {{ $t('lotFlow_detail_summary_activeStatus_' + (summary.activeStatus || 'unknown')) }}
          </a-tag>
        </div>
      </div>
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'SummaryHeaderCard',
  props: {
    summary: {
      type: Object,
      default: () => ({
        gtinCode: null,
        gtinDisplay: null,
        gs1CompanyPrefix3: null,
        ecountProductCode: null,
        dealerProductCode: null,
        productDescription: null,
        ecountToDealerGapDays: null,
        consistencyCheck: { quantityBalance: 'ok', timeline: 'ok' },
        activeStatus: 'unknown',
      }),
    },
  },
  methods: {
    // 정합성 색상 (ok=green, warning=orange, error=red)
    consistencyColor(val) {
      if (val === 'ok') return 'success';
      if (val === 'warning') return 'warning';
      if (val === 'error') return 'error';
      return 'default';
    },
    // 활성 상태 색상
    activeStatusColor(val) {
      if (val === 'in_progress') return 'processing';
      if (val === 'holding') return 'blue';
      if (val === 'depleted') return 'default';
      return 'default';
    },
  },
};
</script>

<style scoped>
.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}
.summary-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.summary-label {
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 500;
}
.summary-value {
  font-size: 14px;
  color: #262626;
  word-break: break-all;
}
.gtin-mono {
  font-family: "SF Mono", "Cascadia Mono", Menlo, monospace;
  letter-spacing: 0.5px;
}
.code-mono {
  font-family: "SF Mono", "Cascadia Mono", Menlo, monospace;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
}
@media (max-width: 767px) {
  .summary-grid {
    grid-template-columns: 1fr;
  }
}
</style>
